import { render, staticRenderFns } from "./camera-dialog.vue?vue&type=template&id=32b45ac7&scoped=true"
import script from "./camera-dialog.vue?vue&type=script&lang=js"
export * from "./camera-dialog.vue?vue&type=script&lang=js"
import style0 from "./camera-dialog.vue?vue&type=style&index=0&id=32b45ac7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b45ac7",
  null
  
)

export default component.exports